import { Client } from '../../client';
import type { TagRepository } from '../../repositories/tagRepository';
import type { ITag } from '../../../entities';
import { Tag } from '../../../entities';
import { handleErrors } from '../../../helpers';
import {
  TagsListResponse,
  TagResponse,
  TagType,
} from '../../../responses/responseTypes';

export default class TagRepositoryImpl implements TagRepository {
  client: Client;

  constructor(client: Client) {
    this.client = client;
  }

  async getTagList(tagType: TagType, page = 1): Promise<Array<ITag>> {
    const { client } = this;
    return new Promise((resolve, reject) => {
      client
        .get<TagsListResponse>(`/${tagType}`, {
          params: {
            page,
          },
        })
        .then((response) => {
          const tagList: Array<ITag> = response.data.items.map(
            (data: TagResponse) => new Tag(data, tagType)
          );
          resolve(tagList);
        })
        .catch((err) => {
          const error = handleErrors(err);
          reject(error);
        });
    });
  }
}
